import { calendarType } from '../../../../enums/calendarType';
import { hebrewDateType } from '../../../../enums/hebrewDateType';
import classes from "./Templates.module.css";

const DateHeaderTemplate = (props) => {
    const { instance, hebrewDate, calendarMode, date } = props;

    return (
        <div className={`${classes.DateHeader} date-header`}>
            <div>{instance.formatDate(date, { format: 'EEEE' })}</div>
            <div className='week-day-in-month'>
                {calendarMode === calendarType.jewish
                    ? hebrewDate(date, hebrewDateType.day)
                    : instance.formatDate(date, { format: 'dd' })}
            </div>
        </div>
    );
};

export default DateHeaderTemplate;